import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, admin, employer }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFFDF9]" data-testid="route-loading">
        <Loader2 className="h-8 w-8 animate-spin text-amber-600" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.needs_onboarding) return <Navigate to="/choose-role" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (employer && user.role !== "employer") return <Navigate to="/dashboard" replace />;
  return children;
}
